class Popup {
  constructor(html, width = '650px', mobileFullScreen = false) {
    this.html = html;
    this.width = width;
    this.mobileFullScreen = mobileFullScreen;

    this.selectors = {
      close: '[data-popup-close]',
      cancel: '[data-popup-cancel]'
    };

    this.initialise();
  }

  initialise() {
    /**
     * If overlay doesn't already exist, create one
     */
    if (!window.overlay) {
      window.overlay = new Overlay();

      window.overlay.loading = true;
    }

    /**
     * If opening popup from drawer, close drawer
     */
    if (window.drawers?.activeDrawer) {
      window.drawers?.closeActiveDrawer();
    }

    /**
     * If another popup is already open, destroy it
     */
    if (window.popup) {
      window.popup.destroy();
    }

    /**
     * Create new popup if html exists
     */
    if (this.html) {
      this.insertContent(this.html);
    }

    window.popup = this;
  }

  /**
   * Get the event type based on selectors
   *
   * @param {Event} e
   * @returns String
   */
  getEventType(e) {
    if (e.target.closest(this.selectors.close) !== null) {
      return 'CLOSE';
    }

    if (e.target.closest(this.selectors.cancel) !== null) {
      return 'CANCEL';
    }

    return 'UNKNOWN';
  }

  onClick(e) {
    const eventType = this.getEventType(e);

    if (eventType === 'CLOSE' || eventType === 'CANCEL') {
      this.close();

      window.overlay.close();
    }
  }

  /**
   * Creates the popup and inserts the HTML, followed by appending to body
   *
   * @param {String} html
   */
  insertContent(html) {
    this.popup = document.createElement('div');
    this.popup.style.setProperty('--maxWidth', this.width);
    this.popup.className = `popup${this.mobileFullScreen ? ' popup-mobile-fullscreen' : ''}`;
    this.popup.innerHTML = `
      <button class="popup-close" data-popup-close>
        <svg class="popup-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g stroke-linecap="square" stroke-width="4" fill="none" stroke="currentColor" stroke-miterlimit="10"><path d="M38 10L10 38M38 38L10 10"/></g></svg>
      </button>
      <div class="popup-content" data-popup-content>
        ${html}
      </div>
    `;

    document.body.appendChild(this.popup);

    this.popup.addEventListener('click', this.onClick.bind(this));

    window.overlay.loading = false;

    setTimeout(() => {
      this.popup.classList.add('active');
    }, 10);
  }

  /**
   * Updates currently open popup with new HTML
   *
   * @param {String} html
   */
  replaceContent(html) {
    window.popup.el.querySelector('[data-popup-content]').innerHTML = html;
  }

  /**
   * Close current popup
   */
  close() {
    this.popup.classList.remove('active');

    if (this.popup.querySelectorAll('.swiper').length > 0) {
      this.popup
        .querySelectorAll('.swiper')
        .forEach((el) => el.swiper.destroy(true, true));
    }

    this.popup.addEventListener(
      'transitionend',
      () => {
        this.destroy(this.popup);
      },
      { once: true }
    );
  }

  /**
   * Destroys the current popup
   */
  destroy(popup = window.popup.el) {
    // Add guard clause to check if popup exists
    if (!popup) return;

    popup.remove();

    window.popup = false;
    window.countrySelectorInstance = null;
    window.intlTelInput = null;
  }

  /**
   * Returns the current popup element
   * @returns {Class}
   */
  get el() {
    return this.popup;
  }
}